import * as React from 'react';
import { IgcGridToolbarComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Provides a context-aware container component for UI operations for the grid components.
 */
export const IgrGridToolbar = createComponent({
  tagName: 'igc-grid-toolbar',
  displayName: 'IgrGridToolbar',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrGridToolbar = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarModule = Component;
